import { BaseClientError, CommonClientError, CommonClientErrorCodeList, CommonClientErrorRegistry, } from "@ascend-ltd/logic-helpers";
const ClientErrorCodeList = [
    ...CommonClientErrorCodeList,
    "business_scope.out_of_business_scope",
    "transport.invalid_transport_values",
    "transport.status_untransferable",
    "transport.invalid_resource_type",
];
class OutOfBusinessScope extends BaseClientError {
    constructor(message, userMessage, e) {
        super({
            name: "OutOfBusinessScopeError",
            errorCode: "business_scope.out_of_business_scope",
            statusCode: 400,
            message: message,
            userMessage: userMessage,
        }, e);
    }
}
class InvalidTransportValues extends BaseClientError {
    constructor(message, userMessage, e) {
        super({
            name: "InvalidTransportValuesError",
            errorCode: "transport.invalid_transport_values",
            statusCode: 400,
            message: message,
            userMessage: userMessage,
        }, e);
    }
}
class StatusUntransferable extends BaseClientError {
    constructor(message, userMessage, e) {
        super({
            name: "StatusUntransferableError",
            errorCode: "transport.status_untransferable",
            statusCode: 400,
            message: message,
            userMessage: userMessage,
        }, e);
    }
}
class InvalidResourceType extends BaseClientError {
    constructor(message, userMessage, e) {
        super({
            name: "InvalidResourceTypeError",
            errorCode: "transport.invalid_resource_type",
            statusCode: 400,
            message: message,
            userMessage: userMessage,
        }, e);
    }
}
export const ClientError = {
    ...CommonClientError,
    OutOfBusinessScope,
    InvalidTransportValues,
    StatusUntransferable,
    InvalidResourceType,
};
export const ClientErrorRegistry = {
    ...CommonClientErrorRegistry,
    "business_scope.out_of_business_scope": OutOfBusinessScope,
    "transport.invalid_transport_values": InvalidTransportValues,
    "transport.status_untransferable": StatusUntransferable,
    "transport.invalid_resource_type": InvalidResourceType,
};
//# sourceMappingURL=client-error.js.map